<template>
  <div class="card panel-white">
    <div class="card-body">
      <label>{{ $t('message.my_reservations.cleaner_name') }}</label>
      <div class="row no-gutters d-flex h-100">
        <div class="col-md-2 col-2">
          <img :src="showPicture(order.professional)" class="img-fluid rounded-circle" alt="">
        </div>
        <div class="col-md-10 col-10 pl-2 align-self-center">
          <div v-if="serviceRequest.service_request_status_id >= 3">
            {{ order.professional.full_name | firstName }}
          </div>
          <div class="text-remark" v-else>
            {{ $t('message.service_request.service_request_waiting_confirmation') }}
          </div>
        </div>
      </div>
      <div class="row mt-3 no-gutters"
           v-if="order.professional && order.paid_status === 1 && serviceRequest.payment_status > 0">
        <div class="col-6 pr-1">
          <a :href="'tel:'+ order.professional.phone" class="btn btn-outline-info btn-block">
            <i class="fas fa-phone"></i> {{ $t('message.button.call') }}
          </a>
        </div>
        <div class="col-6 pl-1">
          <router-link
            :to="{ path: '/message', query: { cid: 0, pid: order.professional.id }}"
            class="btn btn-outline-info btn-block">
            <i class="fas fa-comment-alt-lines"></i> {{ $t('message.button.chat') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      order: Object,
      serviceRequest: Object
    },
    methods: {
      showPicture (professional) {
        if (professional && professional.picture) {
          return professional.full_picture
        } else {
          return '/static/img/unknown.png'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/serviceRequest/Components/ProfessionalSection.vue